import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const issueCountSlice = createSlice({
  name: "issueCount",
  initialState: {},
  reducers: {
    setIssuesCount: (_state: any, action: PayloadAction<any>) => action.payload,
  },
});

export const { setIssuesCount } = issueCountSlice.actions;

export const issueCount = issueCountSlice.reducer;

export default issueCountSlice.reducer;
